module.exports = "<p [innerHTML]=\"description\"></p>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/alg-privacy-modal/alg-privacy-modal.component.html
// module id = ./src/app/components/dialogs/alg-privacy-modal/alg-privacy-modal.component.html
// module chunks = main